export default __webpack_public_path__ + "static/media/KnowBe4.c58e788c.svg";